


















import { computed, defineComponent } from '@vue/composition-api'
import { formatCodeToHumanText } from '@/libs/domains/report/formatters'
import { isItemGroupedBySimple } from '@/libs/domains/report/guards'
import type { PropType } from '@vue/composition-api'
import type { SalesReportGroupedBy } from '@futureecom/futureecom-js/dist/services/order-service'

export default defineComponent({
  name: 'SalesReportGroupedByLabels',

  props: {
    groupedBy: {
      type: [] as PropType<SalesReportGroupedBy>,
      required: true
    },
    groups: {
      type: [String, Array] as PropType<string | unknown[]>,
      default: () => []
    }
  },

  setup(props) {
    const isNullish = computed(() => ['null', ''].some((item) => item === `${props.groups}`))

    const isSimple = computed(() => isItemGroupedBySimple(props.groupedBy))

    return {
      isNullish,
      isSimple,
      formatCodeToHumanText
    }
  }
})
